<template>
    <div class="page exams-page">
        <v-container class="py-0 py-lg-6" :class="{'px-0': phoneOnly}">
            <transition name="fade-transition">
                <purchases v-if="loadedData" :purchases="loadedData" :export-url="`${apiUrl}${url}/export`" @loadMore="loadMore" @search="search" @reset="reset" />
            </transition>
        </v-container>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import Purchases from './Purchases.vue';

export default {
    name: "",
    components: {
        Purchases
    },
    props: {
        url: {required: true}
    },
    data(){
        return {
            loading: false,
            loadedData: null,

            get_url: '',
        }
    },
    computed: {
        ...GlobalComputed,
        apiUrl(){
            return window.apiUrl;
        },
        
    },
    methods: {
        ...GlobalMethods,
        loadData(){
            if (!this.loading){
                this.loading = true;

                window.axios.get(this.get_url).then(response=>{
                    this.loadedData = response.data.purchases;
                    this.loading = false;
                }).catch((e)=>{
                    this.loading = false;
                    if (e && e.response && e.response.status === 404){
                        this.$router.push('/not-found')
                    }else{
                        this.showMsg('حدثت مشكلة أثناء تحميل البيانات');
                    }
                });
            }
        },
        loadMore(page){
            this.get_url = this.get_url.split('&page=')[0] + '&page=' + page; // remove page={value} if exists and add page={page}
            this.loadData();
        },
        search(query){
            if (query){
                this.resetUrl();
                this.get_url += '&query=' + query; // remove page={value} if exists and add page={page}
                this.loadData();
            }else{
                this.reset();
            }
        },
        reset(){
            this.resetUrl();
            this.loadData();
        },
        resetUrl(){
            this.get_url = this.get_url.split('&query=')[0].split('&page=')[0];
        }
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        }
    },
    mounted(){
        this.get_url = `${this.url}?p=1`;
        this.loadData();
    }
};
</script>
<style lang="scss" scoped>

</style>
